import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import CaseComponent from "../common/CaseComponent";

class PrintReportCaseHeader extends Component {
  componentDidMount() {}

  printReport = () => {
    const promise = new Promise((resolve, reject) => {
      try {
        resolve(this.props.onReportPrint());
      } catch (e) {
        reject(Error(e));
      }
    });

    promise.then(
      () => {
        this.props.printContent("report", `Report`);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  render() {
    return (
      <Table.Row>
        <Table.Cell>
          <div className={`no-print`}>
            <Button
              className={"margin-left-10"}
              onClick={() => {
                this.printReport();
              }}
            >
              Print
            </Button>
          </div>
        </Table.Cell>
        <Table.Cell />
        <Table.Cell textAlign={`right`}>
          <div className={`no-print `}>
            <CaseComponent {...this.props} compType={"report"} />
          </div>
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default PrintReportCaseHeader;



// WEBPACK FOOTER //
// ./src/components/reports/PrintReportCaseHeader.js